import { Component, ViewChild } from '@angular/core';
import { OnInit } from "@angular/core";
import { SessionStorageService } from "./../shared/services/session-storage.service";
import { Router } from '@angular/router';
import { SnackbarService } from "./../shared/services/snackbar.service";
import { SharedService } from '../shared/services/shared.service';
import { ValidationService } from "./../shared/services/validation.service";
import { RestrictOutsideScrollService } from '../shared/services/restrict-outside-scroll.service';

import * as newPatientModel from './virtual-consultation-new-patient.model';
import { config } from './../../../config/index';

import { isValidNumber } from 'libphonenumber-js';
import { contactViewPipe } from '../pipes/phone-view.pipe';
import { phoneFormatPipe } from '../pipes/phone-formatter.pipe';

import { SwiperComponent, SwiperDirective, SwiperConfigInterface,
    SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';

@Component({
    template: require('./virtual-consultation-new-patient.component.html'),
    styles: [require('./virtual-consultation-new-patient.component.less')],
    preserveWhitespaces: true,
    providers: [SnackbarService, contactViewPipe, phoneFormatPipe]
})


export class VCNewPatientComponent implements OnInit {

    constructor(
        private phoneFormatPipe: phoneFormatPipe,
        private contactViewPipe: contactViewPipe,
        private _mdlSnackbarService: SnackbarService,
        private _sessionStorageService: SessionStorageService,
        private _validationService: ValidationService,
        private _router: Router,
        private _sharedService:SharedService,
        private _restrictOutsideScrollService: RestrictOutsideScrollService
    ) {}

    private pagination: SwiperPaginationInterface = {
        el: '.swiper-pagination',
        clickable: true,
      };

    public config: SwiperConfigInterface = {};

    @ViewChild("datePicker", { static: false }) dateFieldRef: any;
    @ViewChild("datePickerSecondaryRP", { static: false }) dateFieldRefSecondaryRP: any;

    isMobile: boolean = false;
    locations: any = [];
    doctors: any = [];
    _patientfile: any = {};
    dataRequired: boolean = false;
    dob: any;
    headingClass: string = '';
    contentClass: string = '';
    initialHeight: any;
    initialWidth: any;
    confirmEmailError : boolean = false;
    confirmEmailErrorSecondaryRP : boolean = false;
    contactError: boolean = false;
    contactErrorSecondaryRP: boolean = false;
    contactMethods: any = ['Email', 'Text', 'Phone'];
    nextClickedClass = '';
    prevClickedClass = '';
    patient_type = '';
    preferred_treatment_options: any =[ false, false, false, false];
    referral_methods: any =[];
    tomorrow = new Date(); 
    gender: any ='';

    themeColor: string;

    preImagesAry: any = [];
    dobError: boolean = false;
    dobErrorSecondaryRP: boolean = false;
    showReferralDoc : boolean = false;
    concernImages: any = [
        {name: 'Crowding', image:require("../../assets/images/Crowding.svg")},
        {name: 'Spacing', image:require("../../assets/images/Spacing.svg")},
        {name: 'Crossbite', image:require("../../assets/images/Crossbite.svg")},
        {name: 'Flared Teeth', image:require("../../assets/images/Flared.svg")},
        {name: 'Excessive Overjet', image:require("../../assets/images/Excessive Overjet.svg")},
        {name: 'Underbite', image:require("../../assets/images/Underbite.svg")},
        {name: 'Deepbite', image:require("../../assets/images/Deepbite.svg")},
        {name: 'Openbite', image:require("../../assets/images/Openbite.svg")},
        {name: 'Other', image:require("../../assets/images/Other.svg")},
    ];
    index: number = 0;
    genders: any = ['Male', 'Female', 'Non-Binary'];
    GenderClass: string = 'selector';
    zipError: boolean;
    zipErrorSecondaryRP: boolean;
    postalFormat: any = /^([a-zA-Z]\d[a-zA-Z]\s\d[a-zA-Z]\d)$/;
    zipFormat: any = /\b\d{5}\b/;
    phoneCategory: any = ['home', 'mobile'];
    phoneNumRegex: any =  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    relationValues = ['mother', 'father', 'step-mother', 'step-father', 'guardian', 'other'];
    stateProvinceLabel = 'STATE_PROVINCE';
    stateProvinceLabelSecondaryRP = 'STATE_PROVINCE';
    emailRegex: any = config.emailRegex;
    emailRegexPattern: any = config.emailRegexPattern;
    hasEmailError: boolean;
    hasEmailErrorSecondaryRP: boolean;

    responsiblePartyRequiredFields: any = ['responsible_party_first_name', 'responsible_party_last_name', 'relationship_option',
        'responsible_party_dob', 'mailing_street_address_1', 'city', 'zip_code_postal_code', 'phone_number', 'email', 'confirm_email',
        'best_contact_method'];
    primaryRPOpen: boolean = true;
    secondaryRPOpen: boolean = false;
    openAccordionId: string;
    secondaryRPFields: any = ['secondary_responsible_party_first_name', 'secondary_responsible_party_middle_name', 'secondary_responsible_party_last_name',
        'secondary_relationship_option', 'secondary_responsible_party_dob', 'secondary_mailing_street_address_1', 'secondary_mailing_street_address_2',
        'secondary_city', 'secondary_state_id', 'secondary_country_id', 'secondary_zip_code_postal_code', 'secondary_phone_number', 'secondary_phone_number_type',
        'secondary_email', 'secondary_confirm_email', 'secondary_best_contact_method'];
    secondaryRPValidationFields: any = ['dobErrorSecondaryRP', 'hasEmailErrorSecondaryRP', 'confirmEmailErrorSecondaryRP',
        'contactErrorSecondaryRP', 'zipErrorSecondaryRP'];
    mailingAddressFields: any = ['mailing_street_address_1', 'mailing_street_address_2', 'city', 'state_id' ,'country_id', 'zip_code_postal_code', 'country'];
    sameAsPrimaryCheckbox: boolean;

    practiceCountry: any;
    practiceState: any;

    @ViewChild("confirmSecondaryRPDeleteDialog", {static: false}) confirmSecondaryRPDeleteDialog: any;

    toggleAccordion(type: string) {
        this.openAccordionId = type === 'primary' ? 'accordionSecondary' : 'accordionPrimary';
        this.openAccordion(this.openAccordionId);
    }

    scrollToAccordionTopElement(type: string) {
        this.openAccordionId = type === 'primary' ? 'accordionPrimary' : 'accordionSecondary';

        setTimeout(() => {
            this._sharedService.scrollTo(document.getElementById(this.openAccordionId).getElementsByClassName('required-label')[0]);
        }, 0);

    }

    addSecondaryRP() {
        this._patientfile.hasSecondaryRP = true;

        setTimeout(() => {
            this.toggleAccordion('primary');
            this.scrollToAccordionTopElement('secondary');
        }, 0);
    }

    deleteSecondaryRP() {
        this._patientfile.hasSecondaryRP = false;
        this.confirmSecondaryRPDeleteDialog.close();
        this.sameAsPrimaryCheckbox = false;
        this.toggleAccordion('secondary');

        for (let key of this.secondaryRPFields) {
            delete this._patientfile[key];
        }

        for (let validationKey of this.secondaryRPFields) {
            delete this[validationKey];
        }

        this.setSecondaryRPCountryDetails();
    }

    isRPError() {
        let isError: boolean = false;

        if (this.dobError || this.hasEmailError || this.confirmEmailError || this.contactError) {
            return true; // isError = true
        }

        for (let field of this.responsiblePartyRequiredFields) {
            if (!this._patientfile[field] || this._patientfile[field] == '') {
                isError = true;
                break;
            }
        }

        return isError;
    }

    setSecondaryMailingAddress(event: any) {
        if (!event) {
            return;
        }

        for (let key of this.mailingAddressFields) {
            this._patientfile['secondary_' + key] = this._patientfile[key];
        }

        if (this._patientfile.country.name === 'USA') {
            this.zipFormatter(true, true);
        } else if (this._patientfile.country.name === 'Canada') {
            this.zipFormatter(false, true);
        }
    }

    nextPage() {
        if (this.nextClickedClass !== 'nextClickClass') {
            this.nextClickedClass = 'nextClickClass';
            this.validation(this._patientfile);
            setTimeout(() => {
                this.nextClickedClass = '';
                if (this.dataRequired) {
                    if (this.openAccordionId && this._patientfile.pageIndex === 4 &&
                        ((this.openAccordionId === 'accordionPrimary' && this.primaryRPOpen === false)
                        || (this.openAccordionId === 'accordionSecondary' && this.secondaryRPOpen === false))) {
                        this.openAccordion(this.openAccordionId);
                    }
                    setTimeout(() => {
                        this._sharedService.scrollToError('.text-error');
                    }, 0);
                } else {
                    if (this._patientfile.pageIndex < 8) {
                        if (this._patientfile.locations.length === 1 
                            && (
                                (this.patient_type === "child" && this._patientfile.pageIndex === 4)
                                || (this.patient_type === "adult" && this._patientfile.pageIndex === 3)
                            )
                        ) {
                            this._patientfile.pageIndex = 6;
                            this._patientfile.location_id = this._patientfile.locations[0].id;
                            this._patientfile.location_contact_number = this._patientfile.locations[0].contact_number;
                        } else {
                            this._patientfile.pageIndex = (this.patient_type === "adult" && this._patientfile.pageIndex === 3)
                                ? this._patientfile.pageIndex + 2 : this._patientfile.pageIndex + 1;
                        }
                        this._sessionStorageService.saveItem('patientFile', this._patientfile);
                        this.headingClass = 'heading-height-page-' + this._patientfile.pageIndex;
                        this.contentClass = 'content-height-page-' + this._patientfile.pageIndex;
                        if(this._patientfile.pageIndex === 3 && this.patient_type === "child"){
                            this.headingClass = 'heading-height-page-child';
                            this.contentClass = 'content-height-page-child'; 
                        }
                    } else {
                        this._patientfile.photoType = 1;
                        if (this._patientfile.has_aligner) {
                            delete this._patientfile.has_aligner;
                        }
                        this._sessionStorageService.saveItem('patientFile', this._patientfile);
                        this._router.navigate(['vc-photo-upload'], { replaceUrl: true });
                    }
                }
            }, 300);
        }
    }

    prevPage() {
        this.prevClickedClass = 'prevClickClass';
        setTimeout(() => {
            this.prevClickedClass = '';
            if(this._patientfile.pageIndex >1){
                if (this._patientfile.pageIndex === 8 && (this._patientfile.concernIndex || this._patientfile.concernIndex === 0)) {
                    this.index = this._patientfile.concernIndex;
                }
                if(this._patientfile.locations.length === 1 && this._patientfile.pageIndex ===  6){
                    if (this.patient_type === "child") {
                        this._patientfile.pageIndex = 4;
                    } else {
                        this._patientfile.pageIndex = 3;
                    }
                }else {
                    this._patientfile.pageIndex = this._patientfile.pageIndex - 1;
                }
                if(this.patient_type === 'adult' && this._patientfile.pageIndex === 4){
                    this._patientfile.pageIndex = this._patientfile.pageIndex - 1;
                }
                this._sessionStorageService.saveItem('patientFile', this._patientfile);
                this.headingClass = 'heading-height-page-' + this._patientfile.pageIndex;
                this.contentClass = 'content-height-page-' + this._patientfile.pageIndex;
                if(this._patientfile.pageIndex === 3 && this.patient_type === "child"){
                    this.headingClass = 'heading-height-page-child';
                    this.contentClass = 'content-height-page-child'; 
                }
            } else {
                this._sessionStorageService.saveItem('patientFile', this._patientfile);
                this._router.navigate(['vc-start/' + this._patientfile.token], { replaceUrl: true });
            }
        }, 300);
    }

    openPicker(responsible_party?: boolean) {
        if(document.activeElement instanceof HTMLInputElement) {
            let key = responsible_party ? 'responsible_party_dob' : 'dob';
            document.activeElement.blur();
            setTimeout(this.dateFieldRef.instance.show, 150);
            this.dobError = !this._validationService.validateDate(this._patientfile[key]);
        }   
    }

    openPickerSecondaryRP() {
        if(document.activeElement instanceof HTMLInputElement) {
            document.activeElement.blur();
            setTimeout(this.dateFieldRefSecondaryRP.instance.show, 150);
            this.dobErrorSecondaryRP = !this._validationService.validateDate(this._patientfile.secondary_responsible_party_dob);
        }
    }

    checkDobError(responsible_party?: boolean) {
        let key = responsible_party ? 'responsible_party_dob' : 'dob';
        this.dobError = !this._validationService.validateDate(this._patientfile[key]);
    }

    checkDobErrorSecondaryRP() {
        this.dobErrorSecondaryRP = !this._validationService.validateDate(this._patientfile.secondary_responsible_party_dob);
    }

    selectPatientType(value: any){
        this.patient_type = value;
        if(this.patient_type === 'adult'){
            this._patientfile.adult = 'yes'
        } else {
            this._patientfile.adult = 'no'
        }
    }

    selectConcernType(value:any ){
        this._patientfile.chief_concern = value;
    }

    removeSelectedOption() {
        let i;
        for ( i=0; i<3; i++){
            this.preferred_treatment_options[i] = false;
        }
    }

    removeNoPreferenceOption(){
        this.preferred_treatment_options[3]= false;
    }

    selectConern(index: number) {
        this._patientfile.concernIndex = index;
    }

    removeSwiperSelected() {
        this._patientfile.concernIndex = null;
        this._patientfile.chief_concern = null;
    }

    checkData() {
        this._sessionStorageService.readItem('patientFile').then((data: any) => {
            if(data) {
                this._patientfile = data;
                if (this._patientfile.concernIndex || this._patientfile.concernIndex === 0) {
                    this.index = this._patientfile.concernIndex;
                }

                this.practiceCountry = data.country;
                this.practiceState = data.state;

                this._patientfile.countryCode = this.practiceCountry.code;

                if (this._patientfile.countryCode !== 'US' && this._patientfile.countryCode !== 'CA') {
                    this._patientfile.phone_number = this.phoneFormatPipe.transform(this._patientfile.phone_number, this._patientfile.countryCode);
                }

                this._patientfile.country_id = this.practiceCountry.id;

                if (!this._patientfile.state_id) {
                    this._patientfile.state_id = this.practiceState.id;
                }

                if (this._patientfile.country.name === 'USA') {
                    this.stateProvinceLabel = 'STATE';
                } else if (this._patientfile.country.name === 'Canada') {
                    this.stateProvinceLabel = 'PROVINCE';
                } else {
                    this.stateProvinceLabel = 'STATE_PROVINCE';
                }

                this.setSecondaryRPCountryDetails();

                this.locations = data.locations;
                if(!this._patientfile.phone_number_type){
                    this._patientfile.phone_number_type = 'mobile';
                }
                if(!this._patientfile.secondary_phone_number_type){
                    this._patientfile.secondary_phone_number_type = 'mobile';
                }
                this.referral_methods = data.referral_methods;
                if (data.location_id) {
                    let selectedLocation = this.locations.find((value: any) => value.id === data.location_id);
                    this.doctors = selectedLocation.doctor_list;
                }
                if(data.referral_source_id){
                    let selectedReferralMethod = this.referral_methods.find((value: any) => value.id === data.referral_source_id)
                    if(selectedReferralMethod.text === "Professional Referral"){
                        this.showReferralDoc = true;
                    }
                }
                if(data.preferred_treatment_options){
                    data.preferred_treatment_options.forEach((element:any) => {
                        if (element === 'CLEAR_ALIGNERS') {
                            this.preferred_treatment_options[0] = true;
                        }
                        
                        if(element === 'CLEAR_BRACES'){
                            this.preferred_treatment_options[1] = true;
                        }
                        if(element === 'METAL_BRACES'){
                            this.preferred_treatment_options[2] = true;
                        }
                        if(element === 'NO_PREFERENCE'){
                            this.preferred_treatment_options[3] = true;
                        }
                    });
                }
                if (!this._patientfile.pageIndex) {
                    this._patientfile.pageIndex = 1;
                    this.headingClass = 'heading-height-page-1';
                    this.contentClass = 'content-height-page-1';
                } else {
                    this.headingClass = 'heading-height-page-' + this._patientfile.pageIndex;
                    this.contentClass = 'content-height-page-' + this._patientfile.pageIndex;
                }
            } else {
                this._patientfile.pageIndex = 1;
                this.headingClass = 'heading-height-page-1';
                this.contentClass = 'content-height-page-1';
            }
            this._sessionStorageService.readItem('patient_type').then((data: any) => {
                if(data) {
                    this.patient_type = data;
                    if(this._patientfile.pageIndex === 3 && this.patient_type === "child"){
                        this.headingClass = 'heading-height-page-child';
                        this.contentClass = 'content-height-page-child'; 
                    }
                } 
            });
        });
    }

    setSecondaryRPCountryDetails() {
        if (!this._patientfile.secondary_country_id) {
            this._patientfile.secondary_country = this.practiceCountry;
            this._patientfile.secondary_country_code = this._patientfile.secondary_country.code;

            if (this._patientfile.secondary_country_code !== 'US' && this._patientfile.secondary_country_code !== 'CA' && this._patientfile.secondary_phone_number) {
                this._patientfile.secondary_phone_number = this.phoneFormatPipe.transform(this._patientfile.secondary_phone_number, this._patientfile.secondary_country_code);
            }

            this._patientfile.secondary_country_id = this._patientfile.secondary_country.id;
            if (!this._patientfile.secondary_state_id) {
                this._patientfile.secondary_state_id = this.practiceState.id;
            }

        }
        if (this._patientfile.secondary_country.name === 'USA') {
            this.stateProvinceLabelSecondaryRP = 'STATE';
        } else if (this._patientfile.secondary_country.name === 'Canada') {
            this.stateProvinceLabelSecondaryRP = 'PROVINCE';
        } else {
            this.stateProvinceLabelSecondaryRP = 'STATE_PROVINCE';
        }

        if (!this._patientfile.secondary_phone_number_type) {
            this._patientfile.secondary_phone_number_type = 'mobile';
        }
    }

    setDoctorList(id: any) {
        let selectedLocation = this.locations.find((value: any) => value.id === id);
        this._patientfile.location_contact_number = selectedLocation.contact_number;
    }

    //Gender select styling purpose
    genderSelected() {
        if (this._patientfile.gender !== undefined) {
            this.GenderClass = 'selector';
        }
    }
    
    validation(value: any) {
        const EMAIL_REGEXP = new RegExp(this.emailRegex);
        if (value.pageIndex === 1) {
            if (this._patientfile.adult) {
                this._sessionStorageService.saveItem('patient_type', this.patient_type);
                this.dataRequired = false;
            } else {
                this._mdlSnackbarService.showSnackbar('SELECT_PATIENT_TYPE');
                this.dataRequired = true;
            }
        } else if (value.pageIndex === 2) {
            this._patientfile.preferred_treatment_options = [];
            if(this.preferred_treatment_options[0]){
                this._patientfile.preferred_treatment_options.push('CLEAR_ALIGNERS')
            }
            if(this.preferred_treatment_options[1]){
                this._patientfile.preferred_treatment_options.push('CLEAR_BRACES')
            }
            if(this.preferred_treatment_options[2]){
                this._patientfile.preferred_treatment_options.push('METAL_BRACES')
            }
            if(this.preferred_treatment_options[3]){
                this._patientfile.preferred_treatment_options.push('NO_PREFERENCE')
            }
            if(this._patientfile.preferred_treatment_options[0]){
                this.dataRequired = false;
            } else{
                this._mdlSnackbarService.showSnackbar('SELECT_PREFERRED_TREATMENT_OPTIONS');
                this.dataRequired = true;
            }
        } else if (value.pageIndex === 3) {
            this.hasEmailError = false;
            if (this._patientfile.gender === undefined) {
                this.GenderClass = 'selector radio-invalid';
            }
            if (this.patient_type === "adult") {
                this.dobError = !this._validationService.validateDate(value.dob);
                this.validateContactNumber();

                if (value.first_name && value.last_name
                    && value.first_name !== '' && value.last_name !== ''
                    && value.email && value.email !==''
                    && !this.contactError && value.best_contact_method
                    && this._patientfile.phone_number_type
                    && value.confirm_email && value.confirm_email !== ''
                    && !this.dobError
                    && !this.confirmEmailError && this._patientfile.gender
                    && value.mailing_street_address_1 && value.mailing_street_address_1 !== ''
                    && value.state_id
                    && value.zip_code_postal_code && value.zip_code_postal_code !== '' && !this.zipError
                    && value.city && value.city !== ''
                    ) {
                        if (!EMAIL_REGEXP.test(value.email)) {
                            this._mdlSnackbarService.showSnackbar('PROVIDE_VALID_EMAIL');
                            this.hasEmailError = true;
                            this.dataRequired = true;
                        } else {
                            this.dataRequired = false;
                        }
                } else {
                    this._mdlSnackbarService.showSnackbar('ENTER_VALID_DATA');
                    this.dataRequired = true;
                }
            } else {
                this.dobError = !this._validationService.validateDate(value.dob);
                if (value.first_name && value.last_name && value.first_name !== '' && value.last_name !== '' &&
                    !this.dobError && this._patientfile.gender){
                    this.dataRequired = false;
                } else {
                    this._mdlSnackbarService.showSnackbar('ENTER_VALID_DATA');
                    this.dataRequired = true;
                }
            }
        } else if (value.pageIndex === 4) {
            let primaryRPDataError: boolean = true;
            this.hasEmailError = false;
            this.dobError = !this._validationService.validateDate(value.responsible_party_dob);
            this.validateContactNumber();
            if (value.responsible_party_first_name && value.responsible_party_last_name
                && value.responsible_party_first_name !== '' && value.responsible_party_last_name !== ''
                && value.email && value.email !==''
                && !this.contactError && value.best_contact_method
                && value.confirm_email && value.confirm_email !== ''
                && !this.dobError && !this.confirmEmailError
                && (this.patient_type === 'adult' || value.relationship_option)
                && value.mailing_street_address_1 && value.mailing_street_address_1 !== ''
                && value.state_id
                && value.zip_code_postal_code && value.zip_code_postal_code !== '' && !this.zipError
                && value.city && value.city !== ''
            ) {
                if (!EMAIL_REGEXP.test(value.email)) {
                    this._mdlSnackbarService.showSnackbar('PROVIDE_VALID_EMAIL');
                    this.hasEmailError = true;
                    this.dataRequired = true;
                } else {
                    this.dataRequired = false;
                    primaryRPDataError = false;
                }
            } else {
                this._mdlSnackbarService.showSnackbar('ENTER_VALID_DATA');
                this.dataRequired = true;
            }

            if (!this.dataRequired && this._patientfile.hasSecondaryRP) {
                this.secondaryRPValidation(value);
            }

            if (this.dataRequired) {
                this.openAccordionId = primaryRPDataError ? 'accordionPrimary' : 'accordionSecondary';
            }
        } else if( value.pageIndex === 5) {
            if (this._patientfile.location_id) {
                this.dataRequired = false;
            } else {
                this._mdlSnackbarService.showSnackbar('SELECT_LOCATION');
                this.dataRequired = true;
            }
        } else if( value.pageIndex === 6) {
            if (this._patientfile.referral_source_id) {
                this.dataRequired = false;
                if (this.showReferralDoc) {
                    if (this._patientfile.referral_doctor) {
                        this.dataRequired = false;
                    } else {
                        this._mdlSnackbarService.showSnackbar('ENTER_VALID_DATA');
                        this.dataRequired = true;
                    }
                }
                if (this._patientfile.concernIndex || this._patientfile.concernIndex === 0) {
                    this.index = this._patientfile.concernIndex;
                }
            } else {
                this._mdlSnackbarService.showSnackbar('SELECT_REFERRAL_METHOD');
                this.dataRequired = true;
            }
        } else if ( value.pageIndex === 7) {
            if (this._patientfile.concernIndex || this._patientfile.concernIndex === 0) {
                this.dataRequired = false;
                this._patientfile.chief_concern = this.concernImages[this._patientfile.concernIndex].name;
            } else {
                this._mdlSnackbarService.showSnackbar('SELECT_MAIN_CONCERN');
                this.dataRequired = true;
            }
        } else if (value.pageIndex === 8) {
            if (this.isInvalidDescription(value)) {
                this.dataRequired = true;
                this._mdlSnackbarService.showSnackbar('OTHER_CONCERNS_WARNING');
            } else {
                this.dataRequired = false;
            }
        }
    }

    secondaryRPValidation(value: any) {
        const EMAIL_REGEXP = new RegExp(this.emailRegex);
        this.hasEmailErrorSecondaryRP = false;
        this.dobErrorSecondaryRP = !this._validationService.validateDate(value.secondary_responsible_party_dob);
        this.validateContactNumberSecondaryRP();
        if (value.secondary_responsible_party_first_name && value.secondary_responsible_party_last_name
            && value.secondary_responsible_party_first_name !== '' && value.secondary_responsible_party_last_name !== ''
            && value.secondary_email && value.secondary_email !==''
            && !this.contactErrorSecondaryRP && value.secondary_best_contact_method
            && value.secondary_confirm_email && value.secondary_confirm_email !== ''
            && !this.dobErrorSecondaryRP && !this.confirmEmailErrorSecondaryRP
            && (this.patient_type === 'adult' || value.secondary_relationship_option)
            && value.secondary_mailing_street_address_1 && value.secondary_mailing_street_address_1 !== ''
            && value.secondary_state_id
            && value.secondary_zip_code_postal_code && value.secondary_zip_code_postal_code !== '' && !this.zipErrorSecondaryRP
            && value.secondary_city && value.secondary_city !== ''
        ) {
            if (!EMAIL_REGEXP.test(value.secondary_email)) {
                this._mdlSnackbarService.showSnackbar('PROVIDE_VALID_EMAIL');
                this.hasEmailErrorSecondaryRP = true;
                this.dataRequired = true;
            } else {
                this.dataRequired = false;
            }
        } else {
            this._mdlSnackbarService.showSnackbar('ENTER_VALID_DATA');
            this.dataRequired = true;
        }
    }

    openAccordion(id: string) {
        let accordion: any = document.getElementById(id);

        if (!accordion) {
            accordion = document.getElementById('accordionPrimary');
        }

        accordion.getElementsByClassName('accordion-toggle')[0].click();
    }

    isInvalidDescription(value: any) {
        if(!value.note||value.note.trim()==='') {
            return true;
        }
        return false;
    }

    checkEmail() {
        if(this._patientfile.confirm_email !== this._patientfile.email) {
            this.confirmEmailError = true;
        } else {
            this.confirmEmailError = false;
        }
    }

    checkEmailSecondaryRP() {
        if(this._patientfile.secondary_confirm_email !== this._patientfile.secondary_email) {
            this.confirmEmailErrorSecondaryRP = true;
        } else {
            this.confirmEmailErrorSecondaryRP = false;
        }
    }

    ngOnInit() {
        this.config = {
            direction: 'horizontal',
            effect: "slide",
            speed: 200,
            slidesPerView: 3,
            keyboard: true,
            mousewheel: true,
            scrollbar: false,
            navigation: true,
            pagination: this.pagination,
            centeredSlides: true,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows : true,
            },
            followFinger: false,
            // spaceBetween: 30,
          };

        this._sharedService.appColorSub.subscribe(color => {
            this.themeColor = color
        });

        this.preloadImages(
            newPatientModel.vcNewPatientImages
        );
        this.isMobile = this._sharedService.isMobileOrTabletDevice();
        this.checkData();
        // setting viewport to initial style on soft keyboard(mobile)
        this.initialHeight = document.documentElement.clientHeight;
        this.initialWidth = document.documentElement.clientWidth;
        let that = this;
        window.addEventListener('resize', function(event: any) {
            document.documentElement.style.setProperty('overflow', 'auto')
            const metaViewport = document.querySelector('meta[name=viewport]')
            if (event.currentTarget.innerWidth === that.initialWidth) {
                metaViewport.setAttribute('content', 'height=' + that.initialHeight + 'px, width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')
            } else {
                metaViewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
            }
        });
        this.tomorrow.setDate(this.tomorrow.getDate());
    }

    phoneNumberInput() {
        if (this._patientfile.countryCode !== 'US' && this._patientfile.countryCode !== 'CA') {
            this._patientfile.phone_number = this.phoneFormatPipe.transform(this._patientfile.phone_number, this._patientfile.countryCode);
            this._patientfile.phone_number = this.contactViewPipe.transform(this._patientfile.phone_number);
        } else {
            this._patientfile.phone_number = this.contactViewPipe.transformNational(this._patientfile.phone_number, this._patientfile.countryCode);
        }
        this.validateContactNumber();
    }

    phoneNumberInputSecondaryRP() {
        if (this._patientfile.secondary_country_code !== 'US' && this._patientfile.secondary_country_code !== 'CA') {
            this._patientfile.secondary_phone_number = this.phoneFormatPipe.transform(this._patientfile.secondary_phone_number, this._patientfile.secondary_country_code);
            this._patientfile.secondary_phone_number = this.contactViewPipe.transform(this._patientfile.secondary_phone_number);
        } else {
            this._patientfile.secondary_phone_number = this.contactViewPipe.transformNational(this._patientfile.secondary_phone_number, this._patientfile.secondary_country_code);
        }
        this.validateContactNumberSecondaryRP();
    }

    validateContactNumber() {
        this.contactError = false;
        if (this._patientfile.phone_number && this._patientfile.countryCode) {
            if (this._patientfile.countryCode === 'US' || this._patientfile.countryCode === 'CA') {
                this.contactError = !this.phoneNumRegex.test(this._patientfile.phone_number);
            } else {
                this.contactError = !isValidNumber(this._patientfile.phone_number, this._patientfile.countryCode);
            }
        } else {
            this.contactError = true;
        }
    }

    validateContactNumberSecondaryRP() {
        this.contactErrorSecondaryRP = false;
        if (this._patientfile.secondary_phone_number && this._patientfile.secondary_country_code) {
            if (this._patientfile.secondary_country_code === 'US' || this._patientfile.secondary_country_code === 'CA') {
                this.contactErrorSecondaryRP = !this.phoneNumRegex.test(this._patientfile.secondary_phone_number);
            } else {
                this.contactErrorSecondaryRP = !isValidNumber(this._patientfile.secondary_phone_number, this._patientfile.secondary_country_code);
            }
        } else {
            this.contactErrorSecondaryRP = true;
        }
    }

    preloadImages(imagesAry: any[]) {
        imagesAry.forEach(image => {
            let sampleImg = new Image();
            sampleImg.src = image;
            this.preImagesAry.push(sampleImg);
        });
    }

    showText(id:any){
       this.showReferralDoc = false;
       let selectedReferralMethod = this.referral_methods.find((value: any) => value.id === id)
        if(selectedReferralMethod.text === "Professional Referral"){
            this.showReferralDoc = true;
        }
    }

    onCountryChange(event: any) {
        let selectedCountry = this._patientfile.country_list.filter((item: any) => item.id === event);
        this._patientfile.country = selectedCountry[0];
        this._patientfile.countryCode = this._patientfile.country.code;

        if (this._patientfile.country.name === 'USA') {
            this.stateProvinceLabel = 'STATE';
        } else if (this._patientfile.country.name === 'Canada') {
            this.stateProvinceLabel = 'PROVINCE';
        } else {
            this.stateProvinceLabel = 'STATE_PROVINCE';
        }

        this._patientfile.country_id = this._patientfile.country.id;
        this._patientfile.state_id = '';
        this._patientfile.phone_number = '';
        this._patientfile.zip_code_postal_code = '';

        if (this._patientfile.countryCode !== 'US' && this._patientfile.countryCode !== 'CA') {
            this._patientfile.phone_number = this.phoneFormatPipe.transform(this._patientfile.phone_number, this._patientfile.countryCode);
        }
    }

    onCountryChangeSecondaryRP(event: any) {
        let selectedCountry = this._patientfile.country_list.filter((item: any) => item.id === event);
        this._patientfile.secondary_country = selectedCountry[0];
        this._patientfile.secondary_country_code = this._patientfile.secondary_country.code;

        if (this._patientfile.secondary_country.name === 'USA') {
            this.stateProvinceLabelSecondaryRP = 'STATE';
        } else if (this._patientfile.secondary_country.name === 'Canada') {
            this.stateProvinceLabelSecondaryRP = 'PROVINCE';
        } else {
            this.stateProvinceLabelSecondaryRP = 'STATE_PROVINCE';
        }

        this._patientfile.secondary_country_id = this._patientfile.secondary_country.id;
        this._patientfile.secondary_state_id = '';
        this._patientfile.secondary_phone_number = '';
        this._patientfile.secondary_zip_code_postal_code = '';

        if (this._patientfile.secondary_country_code !== 'US' && this._patientfile.secondary_country_code !== 'CA') {
            this._patientfile.secondary_phone_number = this.phoneFormatPipe.transform(this._patientfile.secondary_phone_number, this._patientfile.secondary_country_code);
        }
    }

    zipFormatter(isZip? : boolean, secondaryRP?: boolean) {
        let zip_key = secondaryRP ? 'secondary_zip_code_postal_code' : 'zip_code_postal_code';
        let zip_error_key = secondaryRP ? 'zipErrorSecondaryRP' : 'zipError';
        if (!isZip) {
            let cleaned = ('' + this._patientfile[zip_key]).replace(/\s/g, ''),
                formattedVal = cleaned;

            const zip = cleaned.substring(0, 3);
            const last = cleaned.substring(3, 6);

            if (cleaned.length > 3) {
                formattedVal = `${zip} ${last}`;
            } else if (cleaned.length > 0) {
                formattedVal = `${zip}`;
            }
            this[zip_error_key] = !this.postalFormat.test(formattedVal);

            setTimeout(() => {
                this._patientfile[zip_key] = formattedVal;
            });
        } else {
            let cleaned = ('' + this._patientfile[zip_key]).replace(/\D/g, '').slice(0, 10);
            this[zip_error_key] = !this.zipFormat.test(cleaned);

            setTimeout(() => {
                this._patientfile[zip_key] = cleaned;
            });
        }
    }
}
